function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "m13.48664,6.42723c-0.8956,-0.8956 -2.15997,-1.4751 -3.52971,-1.4751s-2.63411,0.55316 -3.52971,1.4751c-0.8956,0.8956 -1.4751,2.15997 -1.4751,3.52971s0.5795,2.63411 1.4751,3.52971c0.8956,0.8956 2.15997,1.4751 3.52971,1.4751s2.63411,-0.55316 3.52971,-1.4751c0.8956,-0.8956 1.4751,-2.15997 1.4751,-3.52971s-0.55316,-2.63411 -1.4751,-3.52971zm-0.94828,6.11114c-0.65853,0.65853 -1.58047,1.05364 -2.58143,1.05364s-1.9229,-0.39512 -2.58143,-1.05364s-1.05364,-1.58047 -1.05364,-2.58143s0.39512,-1.9229 1.05364,-2.58143s1.58047,-1.05364 2.58143,-1.05364s1.9229,0.39512 2.58143,1.05364s1.05364,1.58047 1.05364,2.58143s-0.39512,1.9229 -1.05364,2.58143z",
  fill: "currentColor"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "m19.229,9.27207l-2.02826,0c-0.36878,0 -0.68487,0.31609 -0.68487,0.68487c0,0.36878 0.31609,0.68487 0.68487,0.68487l2.02826,0c0.36878,0 0.68487,-0.31609 0.68487,-0.68487c0,-0.36878 -0.31609,-0.68487 -0.68487,-0.68487z",
  fill: "currentColor"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "m9.95694,16.51587c-0.36878,0 -0.68487,0.31609 -0.68487,0.68487l0,2.02826c0,0.36878 0.31609,0.68487 0.68487,0.68487c0.36878,0 0.68487,-0.31609 0.68487,-0.68487l0,-2.02826c0,-0.36878 -0.31609,-0.68487 -0.68487,-0.68487z",
  fill: "currentColor"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "m16.99001,16.04173l-1.44876,-1.44876c-0.23707,-0.26341 -0.68487,-0.26341 -0.94828,0s-0.26341,0.68487 0,0.94828l1.44876,1.44876c0.26341,0.26341 0.68487,0.26341 0.94828,0s0.26341,-0.68487 0,-0.94828z",
  fill: "currentColor"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "m9.95694,0c-0.36878,0 -0.68487,0.31609 -0.68487,0.68487l0,2.02826c0,0.36878 0.31609,0.68487 0.68487,0.68487c0.36878,0 0.68487,-0.31609 0.68487,-0.68487l0,-2.02826c0,-0.36878 -0.31609,-0.68487 -0.68487,-0.68487z",
  fill: "currentColor"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "m17.01635,2.92386c-0.26341,-0.26341 -0.68487,-0.26341 -0.94828,0l-1.44876,1.44876c-0.26341,0.26341 -0.26341,0.68487 0,0.94828c0.23707,0.26341 0.68487,0.26341 0.94828,0l1.44876,-1.44876c0.26341,-0.26341 0.26341,-0.68487 0,-0.94828z",
  fill: "currentColor"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "m2.71313,9.27207l-2.02826,0c-0.36878,0 -0.68487,0.31609 -0.68487,0.68487s0.28975,0.68487 0.68487,0.68487l2.02826,0c0.36878,0 0.68487,-0.31609 0.68487,-0.68487c0,-0.36878 -0.31609,-0.68487 -0.68487,-0.68487z",
  fill: "currentColor"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "m5.29456,14.59297c-0.23707,-0.26341 -0.68487,-0.26341 -0.94828,0l-1.44876,1.44876c-0.26341,0.26341 -0.26341,0.68487 0,0.94828s0.68487,0.26341 0.94828,0l1.44876,-1.44876c0.26341,-0.26341 0.26341,-0.68487 0,-0.94828z",
  fill: "currentColor"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "m5.29456,4.37262l-1.44876,-1.44876c-0.26341,-0.26341 -0.68487,-0.26341 -0.94828,0s-0.26341,0.68487 0,0.94828l1.44876,1.44876c0.26341,0.26341 0.68487,0.26341 0.94828,0s0.26341,-0.68487 0,-0.94828z",
  fill: "currentColor"
});

function SvgSun(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSun);
export default __webpack_public_path__ + "static/media/sun.b34d19d4.svg";
export { ForwardRef as ReactComponent };